export default {"src":"/_next/static/media/rating-star.b7efd474.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};